import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

import Authenticated from 'Components/Layouts/Authenticated';
import PageHeader from "Components/Utilities/PageHeader";
import Section from "Components/Utilities/Section";
import CmsElement from "Components/Utilities/CmsElement";
import {Loading} from "Components/Partials";
import {RenderWYSIWYG} from "Components/Form";
import {MailLink} from "Components/Utilities";

import {getRecordValue} from "Services/CmsHelpers";
import { asset } from "Services/BaseHelpers";

export default class FAQ extends CmsElement {
    /**
     * @var cmsElementIdentifier
     * @type {string}
     */
    cmsElementIdentifier = 'faq';

    /**
     * @var paginate
     * @type {boolean}
     */
    paginate = false;

    /**
     * @var allowUpdate
     * @type {boolean}
     */
    allowUpdate = false;

    /**
     * @var state
     */
    state = {
        working: true,
    };

    render () {
        const { working, records } = this.state;
        const content = {};
        let faq = [];

        if (records) {
            records.data
                .filter(item => getRecordValue(item, 'type').toLowerCase() === 'content')
                .forEach(item => {
                    content[getRecordValue(item, 'title')] = getRecordValue(item, 'content');
                });

            faq = records.data
                .filter(item => getRecordValue(item, 'type').toLowerCase() === 'question')
                .map(item => ({
                    question: getRecordValue(item, 'title'),
                    answer: getRecordValue(item, 'content'),
                }));
        }

        return (
            <Authenticated title="Dashboard">
                <PageHeader
                   imgSrc="headers/faq.jpg"
                />

                {working && <Loading />}

                {!working && (
                    <>
                        <div className="max-w-4xl mx-auto py-10 px-5 md:px-10">
                            <div className="flex justify-center pb-4">
                                <img
                                    src={asset('images/mini-logo.png')}
                                    alt="Logo"
                                    className="block w-20 align-self-center"
                                />
                            </div>

                            <div className="text-center">
                                <RenderWYSIWYG
                                    className="text-black"
                                    content={content['Welcome Text'] ?? ''}
                                />
                            </div>
                        </div>

                        {this.renderFAQSection(faq)}
                    </>
                )}
            </Authenticated>
        );
    }

    renderFAQSection (records) {
        return (
            <Section>
                <section className="grid grid-cols-1 gap-y-3 divide-y border-t-1 border-gray-200 ">
                    {records.map((item, key) => (
                        <details className="group py-1 text-md p-5 text-left" key={`question-${key}`}>
                            <summary className="flex cursor-pointer uppercase flex-row item-left justify-between py-1 marker:[font-size:0px] bmw-bold p-5">
                                {item.question}
                                <FontAwesomeIcon icon={faChevronDown} />
                            </summary>

                            <p className=" bmw-light text-left text-sm p-5">
                                <RenderWYSIWYG content={item.answer} />
                            </p>
                        </details>
                    ))}
                </section>
            </Section>
        );
    }
}
